// ── Backend DTOs (Swagger-aligned) ────────────────────────────────────────────

export enum NotificationType {
  Info       = 0,
  Success    = 1,
  Warning    = 2,
  System     = 3,
  Heritage   = 4,
  Succession = 5,
  Account    = 6,
}

export interface NotifDto {
  id: number;
  type: NotificationType;
  texte:   string | null;
  action:  string | null;
  payload: string | null;
  lu:      boolean;
  luLe:    string | null;
  creeLe:  string | null;
}

export interface UnreadCountDto {
  count: number;
}

// ── Frontend display model ─────────────────────────────────────────────────────

export type AppNotificationType = 'info' | 'warning' | 'success' | 'system';

export interface AppNotification {
  id: number;
  type: AppNotificationType;
  title: string;
  message: string;
  createdAt: string; // ISO 8601
  read: boolean;
  link?: string;
}
